// extracted by mini-css-extract-plugin
export default {"modal_close_btn_main_top":"CustomModalCloseButton_modal_close_btn_main_top__ruCuL","modal_close_btn_main":"CustomModalCloseButton_modal_close_btn_main__lB9bz"};